/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotIntervalAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import IntervalAction from './IntervalAction/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import Tysiav2MinusIcon from 'DesignSystem/Svgs/Tysiav2MinusIcon/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import Tysiav2TenMinuteIntervalIcon from 'DesignSystem/Svgs/Tysiav2TenMinuteIntervalIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SlotIntervalAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/SlotIntervalAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let slotInterval30IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '30.is_selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let slotInterval10IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '10.is_selected',
})
let slotInterval5IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '5.is_selected',
})
  return (<React.Fragment
>
<div
  data-testid="SlotIntervalAction.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1GYEdz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 width={100}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<IntervalAction
{...childProps}
  viewPath={`${viewPath}/IntervalAction`}
 id={30}
 data="slot_interval.30.is_selected"
 isSelectedSlot={slotInterval30IsSelectedValueData}
>
{childProps => (
<Tysiav2MinusIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2MinusIcon`}
 width={dtSpaceXs}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 text="Full day view"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
<div
  data-testid="SlotIntervalAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1GYEdz': dtColorsNeutral300,'--w-3-Z1GYEdz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-4-Z1GYEdz': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 width={100}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<IntervalAction
{...childProps}
  viewPath={`${viewPath}/IntervalAction`}
 id={10}
 data="slot_interval.10.is_selected"
 isSelectedSlot={slotInterval10IsSelectedValueData}
>
{childProps => (
<Tysiav2TenMinuteIntervalIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2TenMinuteIntervalIcon`}
 width={10}
 height={10}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 text="10 minute view"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
<div
  data-testid="SlotIntervalAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z1GYEdz': dtColorsNeutral300,'--w-3-Z1GYEdz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-4-Z1GYEdz': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical1}`}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 width={100}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<IntervalAction
{...childProps}
  viewPath={`${viewPath}/IntervalAction`}
 id={5}
 data="slot_interval.5.is_selected"
 isSelectedSlot={slotInterval5IsSelectedValueData}
>
{childProps => (
<Tysiav2PlusIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 width={dtSpaceXs}
 height={dtSpaceXs}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 text="5 minute view"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}